import { call, delay, put, race, takeEvery } from 'redux-saga/effects';
import { captureException } from '@sentry/nextjs';
import ActionTypes from '../../../../Data/ActionTypes';
import subscribeToNewsletterMutation from './subscribeToNewsletterMutation';
import { incrementMetric } from '../../../../Services/Datadog';
import NewsletterSubscriptionStatus from '../../../../Data/NewsletterSubscriptionStatus';

export function* subscribeToNewsletterWorker({ payload }) {
  const { newsletter, email, dataFields } = payload;

  yield put({
    type: 'NEWSLETTER/setSubscriptionStatus',
    payload: {
      subscriptionStatus: NewsletterSubscriptionStatus.IN_PROGRESS,
    },
  });

  try {
    const { submissionStatus } = yield race({
      submissionStatus: call(subscribeToNewsletterMutation, {
        newsletter,
        email,
        dataFields,
      }),
      timeout: delay(2000),
    });

    if (submissionStatus) {
      yield put({
        type: 'NEWSLETTER/setSubscriptionStatus',
        payload: {
          subscriptionStatus: NewsletterSubscriptionStatus.SUBSCRIBED,
        },
      });
    } else {
      incrementMetric({
        name: 'subscribeToNewsletterError',
        tags: {
          type: 'timeout',
        },
      });

      yield put({
        type: 'NEWSLETTER/setSubscriptionStatus',
        payload: {
          subscriptionStatus: NewsletterSubscriptionStatus.ERROR,
        },
      });
    }
  } catch (error) {
    incrementMetric({
      name: 'subscribeToNewsletterError',
      tags: {
        type: 'exception',
      },
    });

    captureException(error);

    yield put({
      type: 'NEWSLETTER/setSubscriptionStatus',
      payload: {
        subscriptionStatus: NewsletterSubscriptionStatus.ERROR,
      },
    });
  }
}

export const subscribeToNewsletterAction = (newsletter, email, dataFields) => ({
  type: ActionTypes.SUBSCRIBE_TO_NEWSLETTER,
  payload: {
    newsletter,
    email,
    dataFields,
  },
});

/**
 * Redux Watcher
 */
export default function* subscribeToNewsletterWatcher() {
  yield takeEvery(
    ActionTypes.SUBSCRIBE_TO_NEWSLETTER,
    subscribeToNewsletterWorker
  );
}
